import Container, { Service } from 'typedi';

import { TokenType } from '../../../models/enums/general-enums';
import { Utils } from '../../utils';
import { ICrossAutoLoginModel } from '../models';
import { AutoLoginDataBuilder } from './autologindata.builder.service';

@Service()
export class CrossAutoLoginDataBuilder extends AutoLoginDataBuilder<ICrossAutoLoginModel> {
    private readonly _utils: Utils;

    constructor() {
        super();
        this._utils = Container.get(Utils);
    }

    public Build = async (data: any): Promise<ICrossAutoLoginModel> => {
        const loginData: any = Object.fromEntries(data.entries());

        const token = this._normalizeToken(loginData?.UserInfo);

        const { brandId, subBrandId } = this._window.pageContextManager.getBrandData();
        const { productPackage, clientVersion } = this._window.pageContextManager.getDeviceData();

        let loginModel: ICrossAutoLoginModel = {
            ...loginData,
            UserInfo: token,
            AuthenticationInfo:
                loginData.AuthenticationInfo ?? this._getAuthenticationInfo(loginData),
            TargetProductPackage: productPackage,
            ClientVersion: clientVersion,
            BrandID: brandId,
            TargetSubBrand: subBrandId,
            SessionTimer: loginData?.SessionTimer,
            ...(this.shouldSendLoginCountry() && {
                LoginCountryISO3: this._window.pageContextManager.getGlobalizationData().country,
            }),
        };

        loginModel = await this._setLoginNativeProps(loginModel as ICrossAutoLoginModel);

        return loginModel;
    };

    private _normalizeToken = (token) => {
        if (!token) return token;

        return this._utils.stringReplaceAll(token, ' ', '+');
    };

    private _getAuthenticationInfo = (loginData: any) =>
        JSON.stringify({
            TokenData: { TokenType: TokenType.Regular, TokenValue: loginData.UserInfo },
        });
}
